module.exports = __webpack_public_path__ + "media/images/athletes/2387-3476f4d5c49b9a4d68e41031594df599.png";